import { Link } from '@remix-run/react';
import { useIsAuthenticated } from '~/utils/user.js';
import { analytics } from './analytics/segment-tracker.client.tsx';
import { useAppMode } from './dashboard/app-mode-provider.tsx';
import { Button } from './ui/button.tsx';

function useAppButtonContent() {
  const isAuthenticated = useIsAuthenticated();
  const isHostRoute = useAppMode() === 'host';

  if (!isAuthenticated) {
    return {
      text: 'Get Started',
      to: '/signup' as const,
    };
  }

  return {
    text: 'Log-in',
    to: isHostRoute ? ('/app/host' as const) : ('/app' as const),
  };
}

export function AppButton({ className }: { className?: string }) {
  const { to, text } = useAppButtonContent();

  return (
    <Button asChild variant="gradient" className={className}>
      <Link
        className="whitespace-nowrap"
        to={to}
        prefetch="intent"
        onClick={() => {
          if (to === '/signup') {
            analytics.track('Get Started Clicked');
          }
        }}
      >
        {text}
      </Link>
    </Button>
  );
}
